import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GENERATE_OTP_URL, VALIDATE_OTP_URL, TRACK_APPLICATION_URL, TRACK_GEN_NEW_DELIVERY_SHIPMENT_URL_ENCRYPT, RETRIEVE_APPLICATION_URL, orgId, SUBMIT_REFERRAL_URL, EXPAND_MINI_URL, GENERATE_OTP_URL_ENCRYPT, VALIDATE_OTP_URL_ENCRYPT, SUBMIT_REFERRAL_URL_ENCRYPT, TRACK_APPLICATION_URL_ENCRYPT, RETRIEVE_APPLICATION_URL_ENCRYPT, EXPAND_MINI_URL_ENCRYPT, VALIDATE_QDE_OTP_URL_ENCRYPT, VALIDATE_QDE_OTP_URL, RETRIEVE_APPLICATION_URL_DECRYPT, VALIDATE_QDE_OTP_URL_DECRYPT, TRACK_APPLICATION_URL_DECRYPT, GENERATE_NEW_OTP_URL_ENCRYPT, GENERATE_NEW_RETRIEVE_URL, RETRIEVE_AUTH_NEW_URL_ENCRYPT, GENERATE_NEW_TRACK_URL, TRACK_GEN_NEW_URL_ENCRYPT, GENERATE_NEW_RETRIEVE_OTP_URL, GENERATE_NEW_TRACK_OTP_URL, X_SBIC_COOKIE, GENERATE_RETRIEVE_SHORTCODE_OTP_URL, ENCRYPT_FOR_TOKEN_CALL, GENERATE_TOKEN_URL, TRACK_GEN_NEW_SHORTCODE_URL_ENCRYPT, GENERATE_VALIDATE_SHORTCODE_URL } from '../config/app-settings.config';
import { EncrDecrService } from './encr-decr-service.service';
import { Subject, BehaviorSubject, of } from 'rxjs';
import { GeneratedFile } from '@angular/compiler';
import * as generated from "../model/testmodel.model";
declare var _satellite: any;
import appTackDetailMock from '../../assets/mocks/appStatus.json';

@Injectable({
  providedIn: 'root'
})
export class SharedServiceService {
  nameSubject = new BehaviorSubject('');
  analyticsFormAbandon = new BehaviorSubject<any>({});
  nameObservable = this.nameSubject.asObservable()
  dcrSubject = new BehaviorSubject({});
  dcrObservable = this.dcrSubject.asObservable()
  openAddCardFeatureSubject = new BehaviorSubject({});
  openAddCardFeatureObservable = this.openAddCardFeatureSubject.asObservable()
  openProDetailsSubject = new BehaviorSubject({});
  openProDetailsObservable = this.openProDetailsSubject.asObservable()
  openAddDetailsSubject = new BehaviorSubject({});
  openAddDetailsObservable = this.openAddDetailsSubject.asObservable()
  updateAddCardFormSubject = new BehaviorSubject({});
  updateAddCardFormObservable = this.updateAddCardFormSubject.asObservable()
  compDesSubject = new BehaviorSubject({});
  compDesObservavle = this.compDesSubject.asObservable()
  abortMessage:any;
  panDedupeErrorMulticard: any;
  analyticsFormAbandonObj = this.analyticsFormAbandon.asObservable()
  // abortMessage: any;
  sbic_card_Type: any;
  dcSeqId: any;
  paramsappNumber: any;
  paramsmobileNo: any;
  paramsfirstName: any;
  paramsgemid1: any;
  paramsgemid2: any;
  paramschannel: any;
  paramspath: any;
  paramsshortCode: any;
  qdeSuccessResponse: any;
  enableAddOnListFlag: any;
  enableCrossSellFlag: any;
  gemid1Val: any;
  gemid2Val: any;
  // qdeSuccessResponse={
  //     leadRefNo: '22252000010',
  //     applicationNumber: '2233613000018',
  //     bestCardTypes:["AIPU","VPTL","IRCP"] ,
  //     ckycStatus: "CKYC NOT INITIATED",
  //     statusCode: "120",
  //     statusDesc: "Soft Decision - Referred",
  //     upSell: "E",
  //   }
  qdeSubmitData: any;
  //qdeSubmitData={"WSCallUserHouseNo":"321","WSCallUserLocality":"pune","WSCallUserAddressLine":"addline1 teets","WSCallUserResiPincode":"400004","WSCallUserNationality":"IND","WSCallUserSalutation":1,"WSCallUserGender":"M","WSCallExistingCardHolder":"N","WSCallUserFirstName":"akshay","WSCallUserMiddleName":"","WSCallUserLastName":"jain","WSCallUserCity":"MUMBAI","WSCallUserEmailId":"anc@gmail.com","WSCallUserMobileNumber":"9869672575","WSCallCardType":"AISU","WSCallCardCategory":"PLAT","WSCallDomainName":"sbicard","WSCallIpaddress":"3.2.154.53","WSCallHostname":"3.2.154.53","WSCallUserOccupationCode":"T","WSCallUserCompany":"TCS","WSCallUserDesignation":"DEVELOPMENT OFFICER","WSCallUserAnnualIncomeValue":900000,"WSCallUserOfficePincode":"400005","WSCallUserPanNumber":"ayqpj3793d","WSCallUserDOB":"1995-11-14T18:30:00.000Z"}
  officeCity: any;
  officeState: any;
  perState: any;
  resiState: any;
  resiStdCode: any;
  offStdCode: any;
  // officeCity="subhash";
  cApersonalData: any;
  cAprofessisonalData: any;
  cApersonalFormValid: boolean = false;
  cAadditionalData: any;
  cAadditionalCardFeatureData: any;
  autoPinCode: any;
  // tokenVal = sessionStorage.getItem('jwt');
  tokenVal: any = sessionStorage.getItem('jwt') || window['authenticationDetails']['EapplyTokenGenerationResponse']['tokenGenerationResponse']['access_token'];
  s24AccessToken = sessionStorage.getItem("s24_access_token");
  s24TokenExpiryTime = sessionStorage.getItem("s24_expiry_time");
  appCompleted: boolean = false;
  trackApplicationResponse: any;
  //trackAppPartnerResponse: any;
  retrievedApplicationResponse: any;

  navigateToCompleteApp: any;
  navigateToDocUpload: any;
  navigateToScheduleAppointment: any;
  navigateToAddon: any;
  navigateToCrossSell: any;
  navigateToResheduleAppointment: any;
  // navigateToAddon = true;
  // navigateToCrossSell = true;
  feeCodeForDataCapture: any;
  continueWithNewApp: any;
  sbic_card_name: any;
  offerlist = [];
  applicantName: any = '';
  applicantApplicationNumber: any = '';
  initialCardJson: any;
  flagsFromQdeResponse: any;
  resiCity: any;
  //track-app Partner 
  showTrackView: any =true;
  showOtpViewTrack: any = false;

  showFirstName: any = true;
  showOtpViewRetrieve: any = false;
  showMobNum: any = false;

  fromSwiftJourney: boolean = false;

  promoCode = 'DUMY'
 // promoCode = 'DUMY';
  sourceCode: any;
  promoGroup: any;
  InitialMasterResponse: any;
  amoSequeceNumber: any;
  cardName: any;
  existingMessage:any;
  formFieldTouch=false;
  sslEnabled:any = false;
  resetSslEnabled = true;
  uuidString:any;
  pandedupeAbortMessage: any;


  occuVal : any;
  channelVal: any;
  cardsContent: any;
  paramsObc: any;
  cookie: any = sessionStorage.getItem('cookie_new');
  tokenValNew: any = sessionStorage.getItem('jwt_new');
  passphrase: string;
  isSubmit: boolean = false;
  disablenavtabs: any;

  //Digitracking Card Track -> shordcode message flag
  DigitalTrackShortCodeExpiredError: any = '';
  digitrackingCardShortCodeFlag: boolean = false;
  awbnumber: any;
  courierPartnerId: any;
  courierPartnerName: any;
  shortCodeCreditCardNumber: any;
  shortCodeMobileNumber: any;
  shortCodeOrgId: any;
  shotCodeServiceFailedFlag : boolean = false;
  shortCodeReasonCode: any;

  constructor(private http: HttpClient, private encryptDecService: EncrDecrService) {
    this.tokenVal = sessionStorage.getItem('jwt') || window['authenticationDetails']['EapplyTokenGenerationResponse']['tokenGenerationResponse']['access_token'];
    this.tokenValNew = sessionStorage.getItem('jwt_new');
    this.cookie = sessionStorage.getItem('cookie_new');
  }

  sendOtp(mobileNum, emailId, resendRequest, otpReasonCode) {
    let requestBody = {
      creditCardNumber: '000' + mobileNum + '999999',
      mobileNumber: mobileNum,
      //mobileNumber: '9869672575',

      emailId: emailId,
      reasonCode: otpReasonCode,
      resendRequest: resendRequest,
      orgId: orgId,
      regenerationFlag: 'true'
    }

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + this.tokenVal,
        withCredentials: "true",
        "Content-Type": "application/json"
      })
    };
    requestBody = GENERATE_OTP_URL_ENCRYPT ? this.encryptDecService.set(requestBody) : requestBody;
    return this.http.post(`${GENERATE_OTP_URL}`, requestBody, httpOptions);
  }
  callForToken(requestBody) {
    console.log("call for token request", requestBody);
    let httpOptions : any;
    httpOptions = {
      headers : new HttpHeaders({
        "Content-Type": "text/plain"
      }), responseType : 'text'
    }
    requestBody = ENCRYPT_FOR_TOKEN_CALL ? this.encryptDecService.setNew(requestBody, this.passphrase) : requestBody;
    return this.http.post(`${GENERATE_TOKEN_URL}`+this.passphrase, requestBody, httpOptions);
  }
  sendRetrieveOtp(requestBody) {
    console.log("Req body of sendRetrieveOtp from shared ==> ", requestBody);
    let httpOptions : any;
    httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + sessionStorage.getItem('jwt_new'),
        withCredentials: "true",
        "Content-Type": "application/json",
        Cookie: sessionStorage.getItem('cookie_new')
      }), responseType : 'text'
    };
    console.log("HTTP options of sendRetrieveOtp from shared ==> ", httpOptions);
    requestBody = GENERATE_NEW_OTP_URL_ENCRYPT ? this.encryptDecService.set(requestBody) : requestBody;
    console.log("requestBody of sendRetrieveOtp from shared ==> ", requestBody);
    return this.http.post(`${GENERATE_NEW_RETRIEVE_OTP_URL}`, requestBody, httpOptions);
  }
  
  sendRetrieveShortCodeOtp(requestBody) {
    console.log("Req body of sendRetrieveShortCodeOtp from shared ==> ", requestBody);
    let httpOptions : any;
    httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + sessionStorage.getItem('jwt_new'),
        withCredentials: "true",
        "Content-Type": "application/json",
        Cookie: sessionStorage.getItem('cookie_new')
      }), responseType : 'text'
    };
    console.log("HTTP options of sendRetrieveShortCodeOtp from shared ==> ", httpOptions);
    requestBody = GENERATE_NEW_OTP_URL_ENCRYPT ? this.encryptDecService.set(requestBody) : requestBody;
    console.log("requestBody of sendRetrieveShortCodeOtp from shared ==> ", requestBody);
    return this.http.post(`${GENERATE_RETRIEVE_SHORTCODE_OTP_URL}`, requestBody, httpOptions);
  }

  sendTrackOtp(requestBody) {
    console.log("Req body of sendTrackOtp from shared ==> ", requestBody);
    let httpOptions : any;
    httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + sessionStorage.getItem('jwt_new'),
        withCredentials: "true",
        "Content-Type": "application/json",
        Cookie: sessionStorage.getItem('cookie_new')
      }), responseType : 'text'
    };
    console.log("HTTP options of sendTrackOtp from shared ==> ", httpOptions);
    requestBody = GENERATE_NEW_OTP_URL_ENCRYPT ? this.encryptDecService.set(requestBody) : requestBody;
    console.log("requestBody of sendTrackOtp from shared ==> ", requestBody);
    return this.http.post(`${GENERATE_NEW_TRACK_OTP_URL}`, requestBody, httpOptions);
  }

  retrieveAppAuth(requestBody) {
    let httpOptions : any;
    httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + sessionStorage.getItem('jwt_new'),
        withCredentials: "true",
        "Content-Type": "application/json",
        Cookie: sessionStorage.getItem('cookie_new')
      }), responseType : 'text'
    };
    requestBody = RETRIEVE_AUTH_NEW_URL_ENCRYPT ? this.encryptDecService.set(requestBody) : requestBody;
    return this.http.post(`${GENERATE_NEW_RETRIEVE_URL}`, requestBody, httpOptions);
  }

  trackAppAuth(requestBody) {
    let httpOptions : any;
    httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + sessionStorage.getItem('jwt_new'),
        withCredentials: "true",
        "Content-Type": "application/json",
        Cookie: sessionStorage.getItem('cookie_new')
      }), 
      responseType : 'text'
    }
    requestBody = TRACK_GEN_NEW_URL_ENCRYPT ? this.encryptDecService.set(requestBody) : requestBody;
    return this.http.post(`${GENERATE_NEW_TRACK_URL}`, requestBody, httpOptions);
   
      // return of(appTackDetailMock);
  }

  validateOtp(requestBody, otpReasonCode) {
    requestBody.reasonCode = otpReasonCode;
    
    let httpOptions:any;
    if(VALIDATE_QDE_OTP_URL_DECRYPT){
      httpOptions = {
        headers: new HttpHeaders({
          Authorization: "Bearer " + this.tokenVal,
          withCredentials: "true",
          "Content-Type": "application/json"
        }),
        responseType:'text'
      };
    } else{
      httpOptions = {
        headers: new HttpHeaders({
          Authorization: "Bearer " + this.tokenVal,
          withCredentials: "true",
          "Content-Type": "application/json"
        }),
      };
    }
    // const httpOptions = {
    //   headers: new HttpHeaders({
    //     Authorization: "Bearer " + this.tokenVal,
    //     withCredentials: "true",
    //     "Content-Type": "application/json"
    //   })
    // };
    // requestBody = VALIDATE_OTP_URL_ENCRYPT ? this.encryptDecService.set(requestBody) : requestBody;
    // return this.http.post(`${VALIDATE_OTP_URL}`, requestBody, httpOptions);
    requestBody = VALIDATE_QDE_OTP_URL_ENCRYPT ? this.encryptDecService.set(requestBody) : requestBody;
    return this.http.post(`${VALIDATE_QDE_OTP_URL}`, requestBody, httpOptions);
  }

  trackApplication(requestBody) {
    let httpOptions: any;
    if(TRACK_APPLICATION_URL_DECRYPT){
      if (this.s24AccessToken && this.s24TokenExpiryTime) {
        httpOptions = {
          headers: new HttpHeaders({
            Authorization: "Bearer " + this.tokenVal,
            withCredentials: "true",
            "Content-Type": "application/json",
            "access_token": this.s24AccessToken,
            "expiry_time": this.s24TokenExpiryTime
          }),
          observe: 'response',
          responseType:'text' // comment when decryption flag is false
        };
      } else {
        httpOptions = {
          headers: new HttpHeaders({
            Authorization: "Bearer " + this.tokenVal,
            withCredentials: "true",
            "Content-Type": "application/json"
          }),
          observe: 'response',
          responseType:'text' // comment when decryption flag is false
        };
      }
    }else{
      if (this.s24AccessToken && this.s24TokenExpiryTime) {
        httpOptions = {
          headers: new HttpHeaders({
            Authorization: "Bearer " + this.tokenVal,
            withCredentials: "true",
            "Content-Type": "application/json",
            "access_token": this.s24AccessToken,
            "expiry_time": this.s24TokenExpiryTime
          }),
          observe: 'response',
        };
      } else {
        httpOptions = {
          headers: new HttpHeaders({
            Authorization: "Bearer " + this.tokenVal,
            withCredentials: "true",
            "Content-Type": "application/json"
          }),
          observe: 'response',
        };
      }
    }

    requestBody = TRACK_APPLICATION_URL_ENCRYPT ? this.encryptDecService.set(requestBody) : requestBody;
    return this.http.post(`${TRACK_APPLICATION_URL}`, requestBody, httpOptions);
  }

  retriveApplication(requestBody) {
    let httpOptions:any;
    if(RETRIEVE_APPLICATION_URL_DECRYPT){
      httpOptions = {
        headers: new HttpHeaders({
          Authorization: "Bearer " + this.tokenVal,
          withCredentials: "true",
          "Content-Type": "application/json"
        }),
        responseType:'text'
      };
    } else{
      httpOptions = {
        headers: new HttpHeaders({
          Authorization: "Bearer " + this.tokenVal,
          withCredentials: "true",
          "Content-Type": "application/json"
        }),
      };
    }
      // let headers= new HttpHeaders().set(
      //     "Authorization", "Bearer " + this.tokenVal)
      //     .set("withCredentials", "true")
      //     .set("Content-Type", "application/json")
    requestBody = RETRIEVE_APPLICATION_URL_ENCRYPT ? this.encryptDecService.set(requestBody) : requestBody;
    return this.http.post(`${RETRIEVE_APPLICATION_URL}`, requestBody, httpOptions);
  }

  submitReferral(requestBody) {

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + this.tokenVal,
        withCredentials: "true",
        "Content-Type": "application/json"
      })
    };

    requestBody = SUBMIT_REFERRAL_URL_ENCRYPT ? this.encryptDecService.set(requestBody) : requestBody;
    return this.http.post(`${SUBMIT_REFERRAL_URL}`, requestBody, httpOptions);
  }

  getExpandedUrl(shortUrl) {
    return this.http.get(shortUrl);
  }

  getExpandUrlForDocUplod(requestBody) {
    let httpOptions: any;
    if (this.s24AccessToken && this.s24TokenExpiryTime) {
      httpOptions = {
        headers: new HttpHeaders({
          Authorization: "Bearer " + this.tokenVal,
          withCredentials: "true",
          "Content-Type": "application/json",
          "access_token": this.s24AccessToken,
          "expiry_time": this.s24TokenExpiryTime,
        }),
        observe: 'response'
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          Authorization: "Bearer " + this.tokenVal,
          withCredentials: "true",
          "Content-Type": "application/json",
        }),
        observe: 'response'
      };
    }

    requestBody = EXPAND_MINI_URL_ENCRYPT ? this.encryptDecService.set(requestBody) : requestBody;
    return this.http.post(`${EXPAND_MINI_URL}`, requestBody, httpOptions)
  }

// Digital track app shortcode validate new method
  DigitalTrackAppAuthShortcode(requestBody) {
    let httpOptions : any;
    httpOptions = {
      headers: new HttpHeaders({
        Authorization: "Bearer " + sessionStorage.getItem('jwt_new'),
        withCredentials: "true",
        "Content-Type": "application/json",
        Cookie: sessionStorage.getItem('cookie_new')
      }), responseType : 'text'
    };
    requestBody = TRACK_GEN_NEW_SHORTCODE_URL_ENCRYPT ? this.encryptDecService.set(requestBody) : requestBody;
    return this.http.post(`${GENERATE_VALIDATE_SHORTCODE_URL}`, requestBody, httpOptions);
  }

// const createMockResUrl = `assets/mock-jsons/testData.json`;
// return this.http.get<generated.MulticardSubmitRes>(createMockResUrl);
getapplicationtr(){
  // const createMockResUrl = `assets/mocks/testData.json`;
  // return this.http.get<generated.Test>(createMockResUrl);
  return this.http.get('http://localhost:4200/src/assets/mocks/testData.json');
}

  setName(name) {
    this.nameSubject.next(name);
  }

  setDcr(dcr){
    this.dcrSubject.next(dcr);
  }

  setAddCardOpenState(obj){
    this.openAddCardFeatureSubject.next(obj);
  }

  setProDetailsOpenState(obj){
    this.openProDetailsSubject.next(obj);
  }

  setAddDetailsOpenState(obj){
    this.openAddDetailsSubject.next(obj);
  }

  updateAddCardFeatureForm(obj){
    this.updateAddCardFormSubject.next(obj);
  }

  setAnalyticsFormAbandon(obj) {
    this.analyticsFormAbandon.next(obj); 
  }

  setCompDesig(obj) {
    this.compDesSubject.next(obj); 
  }
}
